import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class StatementItemPaymentMatch {
  @Expose()
  @IsString()
  documentNumber!: string;

  @Expose()
  @IsString()
  paymentDate!: string;

  @Expose()
  @IsNumber()
  amount!: number;

  @Expose()
  @IsString()
  currency!: string;
}

export class ContractorStatementPaymentItem {
  @Expose()
  @IsString()
  statementNumber!: string;

  @Expose()
  @IsNumber()
  amountLeft!: number;

  @Expose()
  @IsNumber()
  amount!: number;

  @Expose()
  @IsString()
  accountingDate!: string;

  @Expose()
  @IsArray()
  @Type(() => StatementItemPaymentMatch)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  statementItemPaymentMatches!: Array<StatementItemPaymentMatch>;
}

export class ContractorBankStatementItemResponse extends GenericTableResponse<ContractorStatementPaymentItem> {
  @Expose()
  @IsArray()
  @Type(() => ContractorStatementPaymentItem)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<ContractorStatementPaymentItem>;
}
